export default "<h1>Font Rules 字规则</h1>\n<p>字体配色规则</p>\n"